import axiosInstance from "../../config";

// logout function for logout service

// async funtion for make smoother and faster without waiting of acknowledgement
export const logoutService = async (token) => {

  // Calling api here with the axios Instance 
  try {
    const response = await axiosInstance.get("/v1/logout", {


      headers: {
        Authorization: `Bearer ${token}`,

        "ngrok-skip-browser-warning": "69420"
      },


    });




    //return the status and data the for check the of successfull like 200
    return {
      data: response.data, // return data
      status: response.status //return status 

    }

    //catch errors if something went wrong
  } catch (error) {
    return{

    
   message: error.response?.data?.message || "Logout failed",
      status: error.response?.status || 500,
      errors: error.response?.data?.errors || null,
    }
    
  }
};






